import { RESET_SUCCESS, RESET_ERROR } from "../actions/types";
import firebase from "../../config/firebase";
import {
  signInAction,
  signOutAction,
  authErrorAction,
  setAuthLoading
} from "../actions/authActions";

// Signing in with Firebase
export const signin = (email, password, callback) => async dispatch => {
  dispatch(setAuthLoading(true));
  try {
    firebase
      .auth()
      .signInWithEmailAndPassword(email, password)
      .then(data => {
        // console.log({ user: data.user });
        dispatch(signInAction(data.user));
        localStorage.setItem("token", data.user.refreshToken);
        callback();
      })
      .catch(error => {
        // console.log({ error: error.message });
        dispatch(authErrorAction(error.message));
      });
  } catch (err) {
    console.log({ error: err });

    dispatch(authErrorAction(err.message));
  }
};

// Signing out with Firebase
export const signout = () => async dispatch => {
  dispatch(setAuthLoading(true));
  try {
    firebase
      .auth()
      .signOut()
      .then(() => {
        console.log("signed out---");
        localStorage.removeItem("token");
        dispatch(signOutAction());
      })
      .catch(() => {
        dispatch(authErrorAction("...some error message for the user..."));
      });
  } catch (err) {
    dispatch(authErrorAction("...some error message for the user..."));
  }
};

// Reset password with Firebase
// export const resetPassword = email => async dispatch => {
//   try {
//     firebase
//       .auth()
//       .sendPasswordResetEmail(email)
//       .then(() =>
//         dispatch({
//           type: RESET_SUCCESS,
//           payload: "Reset email sent. Go check your inbox."
//         })
//       )
//       .catch(err => {
//         dispatch({
//           type: RESET_ERROR,
//           payload: "...some message for the user..."
//         });
//       });
//   } catch (err) {
//     dispatch({
//       type: RESET_ERROR,
//       payload: "...some message for the user..."
//     });
//   }
// };
